window.consentScreens = getConsentScreens();
window.lastConsentIndex = 0;

function showConsent() {
    screenType = "consent";
    document.getElementById("image1").onload = function() {
        //adjust size and position based on image dimensions
        var heightConsent = document.getElementById("image1").height;
        var widthConsent = document.getElementById("image1").width;
        document.getElementById("image1").width = widthConsent * adjuster;
        document.getElementById("image1").height = heightConsent * adjuster;
        document.getElementById("image1").style.left = (canvasWidth / 2 - widthConsent * adjuster / 2 - borderImage) + "px";
        setTopButtonForConsent();
    };

    document.getElementById("image1").src = consentImage.src;
    document.getElementById("image1").className = "nonclickableImage";
    document.getElementById("image1").style.top = consentTop + "px";
    document.getElementById("image1").style.display = "block";
    displayText("trialText", textScreens[screenType][language][0]);

    // showOneButtonStandard(textScreens[screenType][language][1]);
    showTwoButtonsForConsent();
    window.logExperimentEvent(window.consortEvents.STARTED_CONSENT);
}

function showTwoButtonsForConsent() {
    const agree = textScreens["consent"][language][1];
    const disagree = textScreens["consent"][language][2];

    const button1 = document.getElementById("button1");
    const button2 = document.getElementById("button2");
    const buttonWidth = 250 * adjuster;
    const spaceButtons = 50 * adjuster;

    button1.innerHTML = agree;
    button1.style.zIndex = 100;
    button1.style.display = "block";

    button2.innerHTML = disagree;
    button2.style.top = +buttonTopDefault-50 + "px";
    button2.style.zIndex = 100;
    button2.style.display = "block";

    button1.style.width = buttonWidth + "px";
    button1.style.left = (canvasWidth / 2 + spaceButtons / 2) + "px";
    button1.style.display = "block";
    button2.style.width = buttonWidth + "px";
    button2.style.left = (canvasWidth / 2 - spaceButtons / 2 - buttonWidth) + "px";
    button2.style.display = "block";

    $('#button2').attr('onclick', 'rejectConsent()');

    setTopButtonForConsent();
}

function endConsent() {
    window.logExperimentEvent(window.consortEvents.PASSED_CONSENT);
    screen_consent = "na";
    displayText("trialText", "");
    hide("button1");
    hide("button2");
    hide("image1");
    cleanMobileTricks();
    // remove the onload handler
    document.getElementById("image1").onload = null;
    $('#button2').attr('onclick', 'clickButton2()');
    $('#button2').text('2');
    main();
}

function showConsent2() {
    screenType = "consent";
    console.log('consentScreens', window.consentScreens);
    if (window.consentScreens.length === 0) {
        screen_consent = "na";
        main();
        return;
    }
    const firstScreen = window.consentScreens.shift();
    showConsentScreen(firstScreen);
    window.logExperimentEvent(window.consortEvents.STARTED_CONSENT);
    adjustStartScreen();
    window.hideAll();
}

function rejectConsent() {
    consent_reject_text = consent_reject_text !== null ? consent_reject_text : trans('consent.8')
    window.logExperimentEvent(window.consortEvents.FAILED_CONSENT);
    $('#consentScreen').hide();
    hide("trialText");
    hide("button1");
    hide("button2");
    hide("image1");
    displayText('content', consent_reject_text);
}

function showConsentScreen(screen) {
    var consentHtml = '';
    for(var i = 0; i < screen.length; i++) {
        consentHtml += generateCurrentConsentHtml(screen[i], i);
    }
    consentHtml += '<div class="message-red" id="consent-error" style="display:none;">You need to fill in all answers first</div>' +
    '<button id="advanceConsent" class="btn btn-primary" type="button" style="font-size:180%;margin-left:auto;margin-right:auto;margin-bottom:20px;display:none" onclick="nextConsentScreen()">'+ textScreens["general"][language]["NEXT"] +'</button>' +
    '<div id="advanceText" style="text-align:center">' + textScreens["consent"][language][7] + '</div>';

    $('#consent-title').text(textScreens["consent"][language][5]);

    $('#consentQuestionContainer').append(consentHtml);
    window.loadplayerfortrials();
    $('#consentScreen').show();
    $('#consentScreen').on('ifChanged', '.radio input', function(e){
        const consentsCount = $('.form-group').length;
        const checkedConsents = $('.form-group input:checked').length;

        if(consentsCount === checkedConsents) {
            $('#advanceConsent').css('display','block');
            $('#advanceText').hide();
        }
    });
}

function nextConsentScreen() {
    const consentsCount = $('.form-group').length;
    const checkedConsents = $('.form-group input:checked').length;

    if(consentsCount !== checkedConsents) {
        $('#consent-error').show();
        return;
    }

    //check if any disagrees were given on consent and stop participation
    if ($('input[value="I disagree"]:checked').length > 0) {
        //redirect to rejection screen
        $('#consentScreen').hide();
        displayText('content', consent_reject_text);
        window.logExperimentEvent(window.consortEvents.FAILED_CONSENT);
        return;
    }

    $('#consentQuestionContainer').html('');
    if(window.consentScreens.length === 0) {
        window.logExperimentEvent(window.consortEvents.PASSED_CONSENT);
        $('#consent-error').hide();
        $('#consentScreen').hide();
        window.hideAll();
        cleanMobileTricks();
        screen_consent = "na";
        main();
        return;
    }

    const nextScreen = window.consentScreens.shift();
    showConsentScreen(nextScreen);
}

function generateCurrentConsentHtml(text, index) {
    const consentImageLocation = window.locationConsent + 'custom/';
    const consentImages = [consent_image1, consent_image2, consent_image3, consent_image4, consent_image5, consent_image6];
    const currentImageIndex = window.lastConsentIndex;

    const currentConsentImgSrc = consentImages[currentImageIndex] !== null ? consentImageLocation + consentImages[currentImageIndex] : "";

    var consentHtml = 
        '<div id="consentRow'+index+'" class="form-normal" style="padding-bottom:30px;">' +
            '<label class="col-sm-12 control-label">'+ text + '</label>' +
        '</div>' +
        '<div class="form-group noBottom withImages">' +
            '<div style="width:100%;">' +
                '<div style="margin-left:1%;margin-right:1%">' +
                    '<img src="' + currentConsentImgSrc +'" style="max-width:100%;margin:auto;display:block;"/>' +
                '</div>' +
                '<form id="formConsentRow'+index+'" style="margin:30px auto;max-width: 300px;">' +
                    '<div class="radio i-checks">' +
                        '<label>' +
                            '<input type="radio" name="formConsentRow'+index+'" data-element="formConsentRow'+index+'" value="I agree"/>' +
                            ' ' + textScreens["consent"][language][3] +
                        '</label>' +
                    '</div>' +
                    '<div class="radio i-checks">' +
                        '<label>' +
                            '<input type="radio" name="formConsentRow'+index+'" data-element="formConsentRow'+index+'" value="I disagree"/>' +
                            ' ' + textScreens["consent"][language][4] +
                        '</label>' +
                    '</div>' +
                '</form>' +
            '</div>' +
        '</div>';

    window.lastConsentIndex++;

    return consentHtml;
}

function getConsentScreens() {
    const consent_texts = [consent_text1, consent_text2, consent_text3, consent_text4, consent_text5, consent_text6];
    const consent_new_screens = [consent_same_screen1, consent_same_screen2, consent_same_screen3, consent_same_screen4, consent_same_screen5];
    const consentImages = [consent_image1, consent_image2, consent_image3, consent_image4, consent_image5, consent_image6];

    var actualScreens = 0;
    for(var i = 0; i < 6; i++) {
        if(consent_texts[i] !== "" || consentImages[i] !== null) {
            actualScreens++;
        }
    }

    if(actualScreens === 0) {
        return [];
    }

    var screensText = [[consent_text1]];
    var currentScreen = 0;
    for(var i = 0; i < consent_new_screens.length; i++) {
        if (consent_new_screens[i] == 1) {
            currentScreen++;
            if (!screensText[currentScreen]) {
                screensText[currentScreen] = [];
            }
        } else if (consent_new_screens[i] === null) {
            break;
        }
        screensText[currentScreen] = screensText[currentScreen].concat(consent_texts[i+1]);
    }
    return screensText;
}

function setTopButtonForConsent() {
    agreeButtonTop = parseInt(document.getElementById("image1").style.top, 10) + parseInt(document.getElementById("image1").height, 10) + 20;
    document.getElementById("button1").style.top = agreeButtonTop + "px";
    document.getElementById("button2").style.top = agreeButtonTop + "px";
}